// src/utils/request.js

const apiClient = {
  post: async (url, body, options = {}) => {
    const { abortSignal, headers = {}, responseType = 'json', ...restOptions } = options

    const defaultHeaders = {
      'Content-Type': 'application/json',
      ...headers,
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: defaultHeaders,
        signal: abortSignal, // 支持中断请求
        ...restOptions,
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      // 根据 responseType 返回不同结果
      if (responseType === 'json') {
        return await response.json()
      } else if (responseType === 'stream') {
        return response.body // 返回 ReadableStream
      } else {
        throw new Error('Unsupported response type')
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.warn('请求被中止')
      } else {
        console.error('请求失败:', error)
      }
      throw error
    }
  },
}

export default apiClient



// WEBPACK FOOTER //
// ./src/views/home/pageSearch/aiRequest.js